import script from "./ParentProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentProduct.vue?vue&type=script&setup=true&lang=js"

import "./ParentProduct.vue?vue&type=style&index=0&id=6041f530&lang=scss&scoped=true"

import exportComponent from "D:\\POS 22\\pawhouse\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6041f530"]])

export default __exports__